module.exports = __webpack_public_path__ + "static/media/logo.43c8278b.svg";